import { FunctionComponent, useContext, useState } from 'react';
import { toast } from 'react-toastify';
import classnames from 'classnames';

import { Locales } from 'types/locale';

import JobFavourite from 'models/JobFavourite';
import { Roles } from 'models/User';

import { select as selectLocale } from 'utils/locale';
import Tracking, { SmEventDescriptons, SmEventTypes } from 'services/Tracking';

import { create as createJobFavourites, remove as removeJobFavourites } from 'requests/jobFavourites';

import LocaleContext from 'components/context/Locale';
import Button, { ButtonIconPositions, ButtonIconTypes, ButtonStyles, ButtonVariants } from 'components/layout/Button';
import ToastSuccessContainer from 'components/layout/ToastSuccessContainer';
import JobLoginModal from 'components/modules/public/layout/modals/JobLoginModal';

import { Props } from './index';
import StyledComponent from './styles';

const PublicLayoutControlsSaveButton: FunctionComponent<Props> = ({ state, jobId, cityId, actions, disabled, iconOnly }) => {
    const localeContext = useContext(LocaleContext);
    const locale = localeContext?.translations;
    const translationsCommon = selectLocale({
        [Locales.Pl]: require('locales/common/pl.json'),
    });

    const [isLoginWorkerModalVisible, setIsLoginWorkerModalVisible]: [boolean, Function] = useState(false);
    const jobFavourite: JobFavourite = state?.user?.jobFavourites.find(jobFavourite => jobFavourite?.job?.id === jobId && jobFavourite?.cityId === cityId);

    const getIconValue = (): string => {
        if (jobFavourite) {
            return '/images/jobs/save-hover.svg';
        }

        return '/images/jobs/save.svg';
    };
    const onSaveJobFavourites = (force: boolean = false) => {
        if (!state.authToken && !force) {
            setIsLoginWorkerModalVisible(true);
        }
        if (state.authToken || force) {
            createJobFavourites({
                jobId,
                cityId,
            })
                .then(() => {
                    toast.success(
                        <ToastSuccessContainer
                            text={translationsCommon?.messages?.dataSaved}
                        />
                        , {
                            closeButton: false,
                        });
                    actions.profileGet();

                    if (state?.user?.email) Tracking.salesManago(
                        state?.user?.email,
                        SmEventTypes.Other,
                        SmEventDescriptons.SavedJobOffer,
                        window.location?.toString(),
                    );
                })
                .catch(() => toast.error(translationsCommon?.messages?.dataSaveError, {
                    closeButton: false,
                }));
        }
    };
    const onRemoveJobFavourties = (force: boolean = false) => {
        if (!state.authToken && !force) {
            setIsLoginWorkerModalVisible(true);
        }
        if (state.authToken || force) {
            removeJobFavourites({
                id: jobFavourite?.id,
            })
                .then(() => {
                    toast.success(
                        <ToastSuccessContainer
                            text={translationsCommon?.messages?.dataSaved}
                        />
                        , {
                            closeButton: false,
                        });
                    actions.profileGet();

                    if (state?.user?.email) Tracking.salesManago(
                        state?.user?.email,
                        SmEventTypes.Other,
                        SmEventDescriptons.SavedJobOffer,
                        window.location?.toString(),
                    );
                })
                .catch(() => toast.error(translationsCommon?.messages?.dataSaveError, {
                    closeButton: false,
                }));
        }
    };
    return (
        <StyledComponent className={
            classnames(
                'public-layout-controls-save-button',
                {
                    'disabled': disabled,
                }
            )
        }
        >
            <Button
                className="save-button"
                style={ButtonStyles.Secondary}
                variant={ButtonVariants.Outline}
                onClick={() => jobFavourite ? onRemoveJobFavourties() : onSaveJobFavourites()}
                icon={{
                    type: ButtonIconTypes.Image,
                    position: ButtonIconPositions.Before,
                    alt: 'zapisz w ulubionych',
                    value: getIconValue(),
                    hover: '/images/jobs/save-hover.svg',
                    width: 24,
                    height: 24
                }}
                disabled={disabled}
                ariaLabel={iconOnly ? 'Zapisz w ulubionych' : undefined}
            >
                {iconOnly ? '' : 'Zapisz w ulubionych'}
            </Button>

            {isLoginWorkerModalVisible && (
                <JobLoginModal
                    {...locale.navigation.loginWorkerModalProps}
                    roleType={Roles.Worker}
                    modalProps={{
                        ...locale.navigation.loginWorkerModalProps.modalProps,
                        onClose: () => {
                            setIsLoginWorkerModalVisible(false);
                        },
                    }}
                    onSuccess={() => {
                        setIsLoginWorkerModalVisible(false);
                        onSaveJobFavourites(true);
                    }}
                />
            )}
        </StyledComponent>
    );
};

export default PublicLayoutControlsSaveButton;